var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.22305 7.18125H32.5428L37.3324 15.2269L20.3801 36.8007L2.64545 15.2124L8.22305 7.18125ZM8.77235 8.23125L4.30685 14.6608H11.1095L13.6612 8.23125H8.77235ZM14.7908 8.23125L12.2392 14.6608H19.8461V8.23125H14.7908ZM20.8961 8.23125V14.6608H28.5029L25.9512 8.23125H20.8961ZM27.0809 8.23125L29.6326 14.6608H35.7734L31.9459 8.23125H27.0809ZM35.6166 15.7108H29.6222L22.4289 32.4939L35.6166 15.7108ZM20.8961 33.405L28.4798 15.7108H20.8961V33.405ZM19.8461 15.7108H12.2622L19.8461 33.405V15.7108ZM18.4355 32.7794L11.1199 15.7108H4.4138L18.4355 32.7794Z",
    fill: "#030303"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.2f956daad50d9fa50f16985f7a0daeee.svg";
export { ForwardRef as ReactComponent };